var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-tool-tip',{attrs:{"label":_vm.label,"position":"top"}},[_c('w-icon',{attrs:{"data-test":_vm.dataTest,"icon":_vm.icon,"size":_vm.size,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }